module.exports = __webpack_public_path__ + "static/media/edit-disable.6a8aee85.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/new-images/edit-disable.svg
// module id = 127
// module chunks = 0